import type { ReactNode } from 'react';
import MainNav from './main-nav';
import SiteFooter from './site-footer';

type PageScaffoldProps = {
  children: ReactNode;
  mainClassName?: string;
  transparentNavAtTop?: boolean;
  showNav?: boolean;
  showFooter?: boolean;
};

export default function PageScaffold({
  children,
  mainClassName = 'pt-28 px-6 md:px-10 pb-20',
  transparentNavAtTop = false,
  showNav = true,
  showFooter = true,
}: PageScaffoldProps) {
  return (
    <div className="app-page">
      {showNav && <MainNav transparentAtTop={transparentNavAtTop} />}
      <main className={mainClassName}>{children}</main>
      {showFooter && <SiteFooter />}
    </div>
  );
}
